<template>
  <div class="min-h-screen bg-white py-8">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="leading-relaxed space-y-10">
        <section>
          <h2 class="text-2xl font-semibold text-primary mb-3">
            1. Acceptance of Terms
          </h2>
          <p>
            By accessing or using MEDIUM.am, you agree to be bound by these
            Terms of Service. If you do not agree to these terms, please do not
            use our platform.
          </p>
        </section>

        <section>
          <h2 class="text-2xl font-semibold text-primary mb-3">
            2. The Service
          </h2>
          <p>
            MEDIUM.am is a community platform designed to connect artists and
            art lovers. We provide tools for profile creation, discovery, and
            networking.
          </p>
          <p class="mt-2">
            <strong>Connector Role:</strong> MEDIUM.am acts solely as a
            facilitator. We do not participate in, nor are we a party to, any
            agreements, sales, or transactions between users.
          </p>
        </section>

        <section>
          <h2 class="text-2xl font-semibold text-primary mb-3">
            3. User Accounts & Security
          </h2>
          <p>
            To use certain features, you must register for an account via email
            or Google Sign-In. You are responsible for:
          </p>
          <ul class="list-disc list-inside mt-2 space-y-1 ml-4">
            <li>
              Providing accurate and complete information (Name, Email, etc.).
            </li>
            <li>Maintaining the security of your account session.</li>
            <li>All activities that occur under your account.</li>
          </ul>
        </section>

        <section>
          <h2 class="text-2xl font-semibold text-primary mb-3">
            4. Payments & Third-Party Dealings
          </h2>
          <p>
            MEDIUM.am does not process payments at this time. Any financial
            transactions, commissions, or purchases of artwork occur strictly
            between the artist and the art lover through their own chosen
            third-party methods.
          </p>
          <p class="mt-2 font-medium text-red-600">
            We are not responsible for any payment disputes, refunds, or failed
            deliveries resulting from interactions between users on the
            platform.
          </p>
        </section>

        <section>
          <h2 class="text-2xl font-semibold text-primary mb-3">
            5. User Content & Conduct
          </h2>
          <p>
            Users are solely responsible for the content (images, bios, text)
            they post. MEDIUM.am is a space for human creativity; therefore:
          </p>
          <ul class="list-disc list-inside mt-2 space-y-1 ml-4 font-medium">
            <li class="text-red-600">
              AI-generated content is strictly prohibited.
            </li>
            <li>
              Content must be directly related to art and the art community.
            </li>
            <li>Content must not infringe on intellectual property rights.</li>
            <li>Illegal, offensive, or harmful material is forbidden.</li>
          </ul>
          <p class="mt-4 bg-gray-50 p-3 border-l-4 border-red-500 italic">
            <strong>Zero Tolerance Policy:</strong> Any non-art related or
            AI-generated materials will be discovered and permanently deleted
            without prior notice.
          </p>
        </section>
        <section>
          <h2 class="text-2xl font-semibold text-primary mb-3">
            6. Instagram Import
          </h2>
          <p>
            When using the Instagram import feature, you must connect an
            Instagram account that you own or are authorized to manage. You may
            import only content that you have the right to use and publish.
          </p>
          <p class="mt-2">
            MEDIUM.am reserves the right to remove imported content that appears
            to have been obtained without authorization or that violates these
            Terms of Service.
          </p>
        </section>
        <section>
          <h2 class="text-2xl font-semibold text-primary mb-3">
            7. Limitation of Liability
          </h2>
          <p>
            MEDIUM.am is provided "as is" without warranties of any kind. We are
            not liable for any indirect, incidental, or consequential damages
            arising from your use of the platform or your interactions with
            other users.
          </p>
        </section>

        <section>
          <h2 class="text-2xl font-semibold text-primary mb-3">
            8. Termination
          </h2>
          <p>
            We reserve the right to suspend or terminate accounts that violate
            these terms or engage in behavior that harms the community.
          </p>
        </section>

        <section>
          <h2 class="text-2xl font-semibold text-primary mb-3">8. Contact</h2>
          <p>Questions about these Terms should be sent to:</p>
          <p class="text-primary font-bold mt-2">contact@medium.am</p>
        </section>
      </div>

      <div class="text-center mt-16 text-sm">
        <p>Thank you for being part of the MEDIUM.am art community.</p>
      </div>
    </div>
  </div>
</template>
